import { Box } from "@mui/material";
import { useTenantContext } from "contexts/tenantContext";
import React from "react";
import { Trans } from "react-i18next";
import { getPrivacyDocument } from "services/document-service";

interface IProps {
    onClose: () => void;
}

const PrivacyMessage = (props: IProps) => {
    const { currentTenant } = useTenantContext();
    const { onClose } = props;

    return (
        <Box>
            <Box>
                <Trans
                    i18nKey="privacy"
                    values={{ zoneName: currentTenant ? currentTenant.displayName : 'PZ Antwerpen' }}
                    components={[
                        <Link onClose={onClose} tenantId={currentTenant?.id} />
                    ]}
                />

            </Box>
        </Box>
    );
};

interface ILinkProps {
    onClose: () => void;
    tenantId?: string;
    children?: React.ReactNode;
}

const Link = (props: ILinkProps) => {
    const { onClose, tenantId } = props;

    async function handleClick() {
        await getPrivacyDocument(tenantId)
            .then((res: Blob) => {
                if (res !== undefined) {
                    // var fileUrl = URL.createObjectURL(res);
                    // const link = document.createElement("a");
                    // link.href = fileUrl;
                    // link.download = `privacy-document.pdf`;
                    // link.click();

                    var fileUrl = URL.createObjectURL(res);
                    window.open(fileUrl, '_blank');
                    onClose();
                }
            })
            .catch((e) => console.log(e));
    }

    return (
        <Box
            component="a"
            sx={{ color: "white", textDecoration: "underline", '&:hover': { cursor: 'pointer' } }}
            onClick={async () => await handleClick()}
        >
            {props.children}
        </Box>
    );
}
export default PrivacyMessage;
